/**
 * 整改提交轮次标签
 *
 * 之前 3 处独立 ternary("idx===0 ? '第一次提交' : idx===1 ? '第二次提交' : `第 N 次提交`"),
 * 前两次中文 + 3 次以后阿拉伯数字,样式不一致.统一抽到这里,全部用阿拉伯数字.
 */
export function formatRoundLabel(idx: number): string {
  return `第 ${idx + 1} 次提交`
}
